import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { LicenceRoleType } from '@enums/licence-role-type.enum';
import { AuthService } from '@services/auth.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class BkoGuard implements CanActivate {

  constructor(
    private authService: AuthService,
    private router: Router) {}

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
      const decodedToken = this.authService.getDecodedToken();
      if (decodedToken?.role === LicenceRoleType.bzd || decodedToken?.role === LicenceRoleType.bko) {
        return true;
      }
      this.router.navigate(['/wiki']);
      return false;
  }

}
